import * as types from "../store/mutation-types";

export default {
    computed: {
        isCompany: {
            get() {
                return this.$store.getters.isCompany;
            },
            set(value) {
                this.$store.commit(types.SET_IS_COMPANY, value);
            }
        },
        firstName: {
            get() {
                return this.$store.getters.clientFirstName;
            },
            set(value) {
                this.$store.commit(types.SET_FIRST_NAME, value);
            }
        },
        lastName: {
            get() {
                return this.$store.getters.clientLastName;
            },
            set(value) {
                this.$store.commit(types.SET_LAST_NAME, value);
            }
        },
        email: {
            get() {
                return this.$store.getters.clientEmail;
            },
            set(value) {
                this.$store.commit(types.SET_EMAIL, value);
            }
        },
        country: {
            get() {
                return this.$store.getters.clientCountry;
            },
            set(value) {
                this.$store.commit(types.SET_COUNTRY, value);
            }
        },
        phone: {
            get() {
                return this.$store.getters.clientPhone;
            },
            set(value) {
                this.$store.commit(types.SET_PHONE, value);
            }
        },
        address: {
            get() {
                return this.$store.getters.clientAddress;
            },
            set(value) {
                this.$store.commit(types.SET_ADDRESS, value);
            }
        },
        companyName: {
            get() {
                return this.$store.getters.companyName;
            },
            set(value) {
                this.$store.commit(types.SET_COMPANY_NAME, value);
            }
        },
        companyAddress: {
            get() {
                return this.$store.getters.companyAddress;
            },
            set(value) {
                this.$store.commit(types.SET_COMPANY_ADDRESS, value);
            }
        },
        registrationNumber: {
            get() {
                return this.$store.getters.registrationNumber;
            },
            set(value) {
                this.$store.commit(types.SET_REG_NUM, value);
            }
        },
        vatNumber: {
            get() {
                return this.$store.getters.vatNumber;
            },
            set(value) {
                this.$store.commit(types.SET_VAT_NUMBER, value);
            }
        },
        iban: {
            get() {
                return this.$store.getters.iban;
            },
            set(value) {
                this.$store.commit(types.SET_IBAN, value);
            }
        },
        bank: {
            get() {
                return this.$store.getters.bank;
            },
            set(value) {
                this.$store.commit(types.SET_BANK, value);
            }
        },
        bic: {
            get() {
                return this.$store.getters.bic;
            },
            set(value) {
                this.$store.commit(types.SET_BIC, value);
            }
        },
        templates: {
            get() {
                return this.$store.getters.templates;
            },
            set(value) {
                this.$store.commit(types.SET_TEMPLATES, value);
            }
        },
        agreeDataTerms: {
            get() {
                return this.$store.getters.agreeDataTerms;
            },
            set(value) {
                this.$store.commit(types.SET_TERMS_AGREE, value);
            }
        },
        agreeMailingList: {
            get() {
                return this.$store.getters.agreeMailingList;
            },
            set(value) {
                this.$store.commit(types.SET_MAILING_LIST_AGREE, value);
            }
        },
        agreeTermsAndConditions: {
            get() {
                return this.$store.getters.agreeTermsAndConditions;
            },
            set(value) {
                this.$store.commit(types.SET_TERMS_CONDITIONS_AGREE, value);
            }
        },
        showPayments: {
            get() {
                return this.$store.getters.showPayments;
            },
            set(value) {
                this.$store.commit(types.SET_SHOW_PAYMENTS, value);
            }
        },
        currentStep: {
            get() {
                return this.$store.getters.currentStep;
            },
            set(value) {
                this.$store.commit(types.SET_CURRENT_STEP, value);
            }
        },
    }
};